export default {
    text: {
        title: 'Text',
        addText: 'New text',
        fontFamily: 'Font family',
        fontSize: 'Font size',
        textAlignment: 'Text alignment',
        fontColor: 'Font color',
        lineSpacing: 'Line spacing',
        arialSerif: 'Arial (sans-serif)',
        verdanaSansSerif: 'Verdana (sans-serif)',
        tahomaSansSerif: 'Tahoma (sans-serif)',
        trebuchetMSSansSerif: 'Trebuchet MS (sans-serif)',
        timesNewRomanSerif: 'Times New Roman (serif)',
        georgiaSerif: 'Georgia (serif)',
        garamondSerif: 'Garamond (serif)',
        courierNewMonospace: 'Courier New (monospace)',
        brushScriptMTCursive: 'Brush Script MT (cursive)',
        backgroundColor: 'Background color',
    },
};
